import React from "react";
import { FormattedMessage } from "react-intl";
import { compose } from "recompose";
import { connect } from "react-redux";

import { setTitleOnPage } from "@app/util";
import { messages } from "@app/messages";
import { AuthState, User } from "@auth/models";
import { getCurrentUser } from "@auth/selectors";
import { DEFAULT_PERIOD_DAYS, getDefaultFromDate, getLatestDate } from "@sales/constants";
import { HeadlineStatsForPeriod } from "@sales/components/HeadlineStatsForPeriod";
import { messages as sMessages } from "@sales/messages";
import { SalesState } from "@sales/models";
import { canViewSales as canViewSalesSelector } from "@sales/selectors";
import { LatestAlbums } from "@music/components/LatestAlbums";
import { messages as mMessages } from "@music/messages";
import { canViewAlbum as canViewAlbumSelector } from "@music/selectors";
import { Page, PageTitle } from "@ui/Page";

interface Props {
    canViewAlbum: boolean;
    canViewSales: boolean;
    user: User;
}

type State = AuthState & SalesState;

const HomePage = ({ canViewAlbum, canViewSales, user }: Props) => {
    return (
        <Page className="home-page">
            <PageTitle className="display-1" tag="h2">
                <FormattedMessage {...messages.welcomeUser} values={{name: user?.name ?? "user"}} />
            </PageTitle>
            {/* The latest albums */}
            {canViewAlbum &&
                <div>
                    <h3 className="display-2">
                        <FormattedMessage {...mMessages.latestAlbums} />
                    </h3>
                    <LatestAlbums />
                </div>
            }
            {canViewSales && (
                <>
                    <h3 className="display-2"><FormattedMessage {...sMessages.performanceTitle} /></h3>
                    <div className="home-page__stats">
                        <HeadlineStatsForPeriod
                            from={getDefaultFromDate().toDate()}
                            to={getLatestDate().toDate()}
                            period={
                                <FormattedMessage
                                    {...sMessages.periodTheLastNDays}
                                    values={{ n: DEFAULT_PERIOD_DAYS }}
                                />
                            }
                        />
                    </div>
                </>
            )}
        </Page>
    );
};

const mapStateToProps = (state: State): Props => ({
    canViewAlbum: canViewAlbumSelector(state),
    canViewSales: canViewSalesSelector(state),
    user: getCurrentUser(state),
});

const ConnectedHomePage = compose<Props, {}>(
    setTitleOnPage(messages.pageHomeTitle),
    connect(mapStateToProps, null),
)(HomePage);

export {
    HomePage as HomePagePresenter,
    ConnectedHomePage as HomePage,
};
